import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { getFarmer } from "../../../../redux/reducer/farmer/farmerReducer";
import SpvReportDailyActivityTable from "./SpvReportDailyActivityTable";
import { getReportActivityAll } from "../../../../redux/reducer/dailyActivity/reportDailyActivityReducer";
import moment from "moment";
import { PictureAsPdf } from "@mui/icons-material";
import { downloadData } from "../../../../service/Service";
import { LoadingButton } from "@mui/lab";

const useStyles = makeStyles(() => ({
  headerClassSearch: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    padding: "0px 5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function SpvReportDailyActivity() {
  // Styling
  const styles = useStyles();

  //Redux
  const data = useSelector((state) => state.reportDailyActivity.data.reportAll);
  const loading = useSelector((state) => state.reportDailyActivity.isLoading);
  const token = useSelector((state) => state.auth.token);
  const farmer = useSelector((state) => state.farmer.data);
  const dispatch = useDispatch();

  // Local State
  const [formInput, setFormInput] = useState({
    to: "",
    from: "",
  });

  const [petani, setPetani] = useState([]);
  const [allFarmers, setAllFarmers] = useState(false);
  const [show, setShow] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPetani(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeCheckbox = (e) => {
    setAllFarmers(e.target.checked);
  };

  const handleChangeInput = (e) => {
    setFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let farmerIds = [];
    for (let x in petani) {
      farmerIds.push(petani[x]);
    }

    const formData = {
      data: {
        selectedFarmer: !allFarmers,
        farmerId: { $in: farmerIds },
        createdAt: {
          $gte: moment(formInput.from).format(),
          $lte: moment(formInput.to).format(),
        },
      },
      token: token,
    };
    dispatch(getReportActivityAll(formData)).then((res) => {
      toast.success(res.payload.message);
      setShow(true);
    });
  };

  const handleReset = () => {
    setShow(false);
    setFormInput({
      to: "",
      from: "",
    });
    setPetani([]);
    setAllFarmers(true);
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 200
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      }
    }
  };

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
      onScroll: loadMore(1),
    },
  };

  const handleDownloadReport = () => {
    setLoadingDownload(true);
    let farmerIds = [];
    for (let x in petani) {
      farmerIds.push(petani[x]);
    }

    const formData = {
      data: {
        selectedFarmer: !allFarmers,
        farmerId: { $in: farmerIds },
        createdAt: {
          $gte: moment(formInput.from).format(),
          $lte: moment(formInput.to).format(),
        },
      },
      token: token,
    };
    downloadData(
      "/farmer/daily-activity/report/export",
      formData.token,
      formData.data
    )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `LAPORAN_AKTIFITAS_HARIAN_PETANI_${moment(formInput.from).format(
            "DD-MMM-YYYY"
          )}_SAMPAI_${moment(formInput.to).format("DD-MMM-YYYY")}.pdf`
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        setLoadingDownload(false);    
      })
      .catch((err) => {
        if(err){
          setLoadingDownload(false);
        }
      });
  };
  return (
    <>
      <ToastContainer />
      <Card className={styles.headerClassSearch}>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <Grid padding={0.5} container spacing={0.5} flexDirection={"column"}>
            <Grid
              item
              container
              xs={12}
              sm={12}
              direction="row"
              alignItems="center"
              justifyContent={"space-between"}
            >
              <div
                style={{ display: "flex", alignItems: "center", width: "30%" }}
              >
                <Typography variant="h6" color="primary">
                  LAPORAN AKTIFITAS HARIAN PETANI
                </Typography>
              </div>
              <div style={{ display: "flex", width: "50%" }}>
                <FormControl
                  variant="standard"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    margin: "10px",
                  }}
                >
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="Dari"
                    name="from"
                    size="small"
                    type="date"
                    required
                    onChange={handleChangeInput}
                    value={formInput.from}
                    variant="outlined"
                    style={{ width: "49%" }}
                  />
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="Ke"
                    name="to"
                    size="small"
                    type="date"
                    required
                    onChange={handleChangeInput}
                    value={formInput.to}
                    variant="outlined"
                    style={{ width: "49%" }}
                  />
                </FormControl>
              </div>
            </Grid>
            <Divider style={{ width: "100%", border: "1px solid black" }} />
            <Grid
              item
              container
              xs={12}
              sm={12}
              direction="column"
              justifyContent="space-evenly"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "80%",
                }}
              >
                <div style={{ width: "15%" }}>
                  <Typography>Petani</Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "85%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <FormControl sx={{ margin: "5px", width: 300 }}>
                      <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        disabled={allFarmers}
                        value={petani}
                        required
                        size="small"
                        onChange={handleChange}
                        renderValue={(selected) => (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected.map((value) => (
                              <Chip key={value._id} label={value.fullName} />
                            ))}
                          </Box>
                        )}
                        MenuProps={MenuProps}
                      >
                        {farmer.docs.map((data, index) => (
                          <MenuItem key={index} value={data}>
                            {data.fullName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Semua Petani"
                        value={allFarmers}
                        onChange={handleChangeCheckbox}
                      />
                    </FormGroup>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid
              container
              item
              justifyContent="flex-end"
              xs={12}
              sm={12}
              marginBottom={1}
            >
              <LoadingButton
                variant="contained"
                size="small"
                style={{ margin: "0px 5px" }}
                type="submit"
                loading={loading}
              >
                Submit
              </LoadingButton>
              <Button
                variant="contained"
                size="small"
                color="error"
                style={{ margin: "0px 10px" }}
                onClick={() => handleReset()}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </form>
      </Card>

      <Card
        style={{
          padding: "10px",
          background: "#F2F2F2",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {show ? (
          <>
            <LoadingButton
              style={{
                margin: "20px 0px",
                backgroundColor: "#AE3336",
                width: "20%",
              }}
              variant="contained"
              onClick={() => handleDownloadReport()}
              loading={loadingDownload}
            >
              Download PDF
              <i style={{ alignItems: "center" }}>
                <PictureAsPdf />
              </i>
            </LoadingButton>
            <SpvReportDailyActivityTable data={data} />
          </>
        ) : (
          <Typography fontStyle={"italic"}>
            Silahkan Mengisi Form Terlebih Dahulu*{" "}
          </Typography>
        )}
      </Card>
    </>
  );
}
